import { Armchair, Car, ChefHat, Gift, KeyRound, PawPrint, Snowflake, Tv, WashingMachine } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "./Reveal";
import { Section } from "./Section";

const ICONS = { ChefHat, Tv, Snowflake, WashingMachine, Armchair, KeyRound, Car, PawPrint, Gift };

export const Comfort = () => {
  const { t } = useLang();
  return (
    <section className="py-14 sm:py-20" data-testid="comfort-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Section eyebrow={t.comfort.eyebrow} title={t.comfort.title} testid="comfort-heading" />
        <div className="grid gap-3.5 sm:grid-cols-2 lg:grid-cols-3">
          {t.comfort.items.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <Reveal key={item.t} delay={i * 0.04}>
                <div
                  data-testid={`comfort-card-${i}`}
                  className="group flex h-full items-center gap-4 rounded-2xl border border-border bg-white px-5 py-4 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-sand-deep text-terracotta transition-colors duration-300 group-hover:bg-terracotta group-hover:text-sand">
                    <Icon size={20} />
                  </span>
                  <h3 className="font-serif text-base font-semibold leading-snug text-ink">{item.t}</h3>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
